import axios from 'axios';

import type { GetApiV1TeamMembersByUsernameResponse } from '~/api/generated';

export async function fetchTeamMember(
  username: string,
): Promise<GetApiV1TeamMembersByUsernameResponse> {
  const { data } = await axios.get<GetApiV1TeamMembersByUsernameResponse>(
    `/api/v1/team_members/${encodeURIComponent(username)}`,
  );

  return data;
}

export async function checkinTeamMember(username: string): Promise<void> {
  await axios.post(`/api/v1/team_members/${encodeURIComponent(username)}/checkin`);
}
